import {
  ActionIcon,
  Button,
  CloseButton,
  Divider,
  Group,
  Paper,
  TextInput,
  ThemeIcon,
} from "@mantine/core";
import React, { useMemo } from "react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import {
  IconArrowRight,
  IconDeviceFloppy,
  IconSend,
} from "@tabler/icons-react";

const NurturingPageHeader = ({
  name,
  setName,
  nurturing,
  activeStep,
  setActiveStep,
  handleClose,
  handleFinish,
  // filterError,
  // setFilterError,
  // workflowError,
  // setWorkflowError,
  // contactsErrors,
  // setContactsError,
}) => {
  const lang = useLanguage((s) => s.language);
  const steps = useMemo(
    () => [
      {
        label: lang.prm.nurturing.step_filter,
        value: "filters",
        error: false,
      },
      {
        label: lang.campaign.steps.contacts,
        value: "contacts",
        error: false,
      },
      {
        label: lang.campaign.steps.workflow,
        value: "workflow",
        error: false,
      },
      {
        label: lang.campaign.steps.programmation,
        value: "program",
      },
      {
        label: lang.campaign.steps.recap,
        value: "review",
      },
    ],
    [lang]
  );

  const handleStep = (step) => {
    return setActiveStep(step.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const fd = new FormData(e.target);
    const data = Object.fromEntries(fd);

    if (activeStep === "filters") {
      return document.getElementById("filter-apply-button").click()
    }

    if (activeStep !== "review") {
      setActiveStep(
        steps[steps.findIndex((x) => x.value === activeStep) + 1]?.value
      );
    } else {
      handleFinish();
    }
  };

  return (
    <Paper
      radius={"lg"}
      style={{ boxShadow: "#00000021 0 1px 3px" }}
      px={"md"}
      pl={4}
      w={"100%"}
      component={"form"}
      id="head-form"
      onSubmit={handleSubmit}
    >
      <Group gap={0} h={61} wrap="nowrap">
        <Group wrap="nowrap" gap={"md"} ml={8}>
          <CloseButton size={40} onClick={handleClose} />
          <TextInput
            placeholder={lang.prm.nurturing.create_name}
            w={"100%"}
            name="name"
            required
            value={name}
            id="nurturing-name"
            radius={"md"}
            size="md"
            onChange={(e) => setName(e.target.value)}
            styles={{ input: { background: "#fff" } }}
            autoFocus
            data-autofocus
          />

          <button
            id="nurturing-config-submitter"
            type="submit"
            style={{ display: "none" }}
          />
        </Group>

        <Group wrap="nowrap" gap={"md"} ml={"auto"}>
          {steps.map((step, i) => {
            let active = step.value === activeStep;
            return (
              <Button
                key={step.value}
                variant={
                  active
                    ? "light"
                    : step.error
                    ? step.value === "contacts" && activeStep === "workflow"
                      ? "subtle"
                      : "light"
                    : "subtle"
                }
                size="sm"
                radius={"md"}
                color={
                  active
                    ? "primary"
                    : step.error
                    ? step.value === "contacts" && activeStep === "workflow"
                      ? "black"
                      : "red"
                    : "black"
                }
                onClick={() => handleStep(step)}
                leftSection={
                  <ThemeIcon
                    radius={"md"}
                    variant="outline"
                    size={"sm"}
                    fz={12}
                    color={
                      active
                        ? "primary"
                        : step.error
                        ? step.value === "contacts" && activeStep === "workflow"
                          ? "black"
                          : "red"
                        : "black"
                    }
                  >
                    {i + 1}
                  </ThemeIcon>
                }
              >
                {step.label}
              </Button>
            );
          })}

          <ActionIcon
            size="36"
            w={48}
            radius={"md"}
            type={"submit"}
            id="nurturing-submit"
          >
            {activeStep === "review" ? (
              nurturing?.id === "create" ? (
                <IconSend size={22} />
              ) : (
                <IconDeviceFloppy size={22} />
              )
            ) : (
              <IconArrowRight size={22} />
            )}
          </ActionIcon>
        </Group>
      </Group>
    </Paper>
  );
};

export default NurturingPageHeader;
